import React from 'react';

// Styles
import './SidebarMapFiltersDivider.scss';

function SidebarMapFiltersDivider() {
  return <hr className='SidebarMapFiltersDivider' />;
}

export default SidebarMapFiltersDivider;
